import { useRef, useEffect, useState } from 'react';
import { ScrollShadow } from "@heroui/react";
import ArtworkInventoryModal from './ArtworkInventoryModal';
import InventoryArtwork from './InventoryArtwork';

export default function ArtworkGroup({ page, artwork }) {
  const scrollContainerRef = useRef(null);
  const [selectedArtwork, setSelectedArtwork] = useState(null);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      e.preventDefault();
      container.scrollLeft += e.deltaY;
    };

    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-4">{page} Artwork</h2>

      <div className="w-full bg-slate-700/30 rounded-xl p-4 min-h-[550px] flex items-center">
        {artwork.length === 0 ? (
          <div className="text-center text-slate-400 w-full text-lg italic">
            No artwork owned of this page
          </div>
        ) : (
          <ScrollShadow orientation="horizontal">
            <div
              ref={scrollContainerRef}
              className="flex gap-4 overflow-x-auto overflow-y-hidden px-1"
            >
              {artwork.map((aw, index) => (
                <div
                  key={index}
                  className="w-[512px] h-[512px] bg-slate-900 rounded-lg border border-slate-600 shadow-md flex items-center justify-center"
                >
                  <InventoryArtwork artwork={aw} onClick={() => setSelectedArtwork(aw)}/>
                </div>
              ))}
            </div>
          </ScrollShadow>
        )}
      </div>
      {selectedArtwork && (
        <ArtworkInventoryModal
          page={page}
          artworkId={selectedArtwork.id}
          artwork={selectedArtwork}
          onCloseModal={() => setSelectedArtwork(null)}
        />
      )}
    </div>
  );
}
